import { SvgIcon, Typography } from "@mui/material";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import Tooltip from "@mui/material/Tooltip";
import { ReactComponent as arrowIcon } from "assets/icons/icon-arrow.svg";
import { useTranslation } from "react-i18next";
import { useStyles } from "./breadCrumbStyles";
import { KEY_CODE } from "utils/constants";

export const BreadCrumb = ({
  breadCrumbData,
  handleBreadCrumbClick,
  separator,
  hideArrow,
  breadCrumbClass,
}: any) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const parseData = breadCrumbData ? JSON.parse(breadCrumbData) : { data: [], searchString: "" };
  const handleClick = (e: any, path: string, breadCrumbKey: any) => {
    e.preventDefault();
    handleBreadCrumbClick(path, breadCrumbKey);
  };
  return (
    <div className={classes.root}>
      <Breadcrumbs aria-label={t("aria_label_breadcrumb")} separator={separator}>
        {parseData.data.map((index: any, key: any) => {
          return (
            <span
              key={index.path}
              className={classes.crumbLink}
              tabIndex={0}
              onClick={(e) => handleClick(e, index.path, key)}
              onKeyDown={(e) => {
                if (e.key.toUpperCase() === KEY_CODE.ENTER || e.key === KEY_CODE.SPACE) {
                  e.preventDefault();
                  handleBreadCrumbClick(index.path, key);
                }
              }}
              role="link"
              aria-current={key === parseData.data.length - 1 ? "page" : "false"}
            >
              {index.title === t("home") ? (
                <span className={`${breadCrumbClass || "bread-crumb"} ${classes.homeLinkSpan}`}>
                  {hideArrow || <SvgIcon component={arrowIcon} className={classes.homeArrow} />}
                  <Typography className={classes.homeTypo}>{index.title}</Typography>
                </span>
              ) : (
                <Tooltip
                  title={
                    `${index.title}` +
                    `${
                      index.title === t("search_results_title") &&
                      JSON.parse(breadCrumbData).searchString.length > 0
                        ? " (" + JSON.parse(breadCrumbData).searchString + ")"
                        : ""
                    }`
                  }
                >
                  <Typography
                    className={`${breadCrumbClass || "bread-crumb"} ${classes.otherlinkTypo}`}
                    style={{ fontWeight: key === parseData.data.length - 1 ? "bold" : "normal" }}
                  >
                    {index.title}
                    {index.title === t("search_results_title") &&
                      parseData.searchString.length > 0 &&
                      " (" + parseData.searchString + ")"}
                  </Typography>
                </Tooltip>
              )}
            </span>
          );
        })}
      </Breadcrumbs>
    </div>
  );
};
